// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__vC3Me","productName":"Table_productName__3iDxF"};